import { Stack, Typography } from "@mui/material";

interface IInsights {
  title: string;
  description: string;
  bron: string;
}

const insights: IInsights[] = [
  {
    title: "Inzicht 1",
    description: "11 van de 14 respondenten denkt niet bewust na over brandgevaar in huis",
    bron: "Enquête, 2024",
  },
  {
    title: "Inzicht 2",
    description:
      "De doelgroep vertoont nonchalant gedrag en gebrek aan kennis over brandveiligheid",
    bron: "Interviews, 2024",
  },
  {
    title: "Inzicht 3",
    description: "Eén op vier studentenhuizen voldoet niet aan de brandveiligheidseisen",
    bron: "NOS, 2023",
  },
  {
    title: "Inzicht 4",
    description: "Studenten voelen zich niet voorbereid op een noodsituatie in hun huis",
    bron: "Interviews, 2024",
  },
  {
    title: "Inzicht 5",
    description: "Een derde van de studentenhuizen heeft geen brandblusser",
    bron: "NOS, 2022",
  },
];

export default function Insights() {
  return (
    <Stack p={8} bgcolor="#F4F8FF" alignItems="center" spacing={3}>
      <Typography color="#20487E" variant="h3" fontWeight="bold">
        Onze ontwerpopgave
      </Typography>

      <Typography width={700} fontSize="18px" textAlign="center" color="#888">
        Bekijk hieronder de belangrijkste inzichten uit ons onderzoek die wij meenemen naar de
        conceptfase.
      </Typography>

      <Stack direction="row" spacing={4}>
        {insights.map((insight, index) => (
          <Stack
            justifyContent="space-between"
            key={index}
            bgcolor="#97BBFF"
            width="170px"
            height="180px"
            borderRadius="15px"
            p={2}
          >
            <Typography variant="h5" fontWeight="bold" color="#FFF">
              {insight.title}
            </Typography>

            <Typography width={150} color="#FFF">
              {insight.description}
            </Typography>
            <Typography color="#20487E">{insight.bron}</Typography>
          </Stack>
        ))}
      </Stack>
    </Stack>
  );
}
